import { format } from 'date-fns'
import {
  IProductSchema,
  IReportProps,
  IUsersInfo,
  TicketReportInput,
} from '../model'
import { FIXTAB_BFF, MICROSITE } from 'helpers/constants'

const getDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return ''
  try {
    return format(new Date(dateStr), 'dd-MM-yyyy')
  } catch (error) {
    return ''
  }
}

const getTime = (dateStr: string | null | undefined): string => {
  if (!dateStr) return ''
  try {
    return format(new Date(dateStr), 'HH:mm:ss')
  } catch (error) {
    return ''
  }
}

const safeGetString = (value: string | null): string => {
  return value?.toString() || ''
}

const safeGetArray = <T>(arr: T[] | null | undefined): T[] => {
  return Array.isArray(arr) ? arr : []
}

const formatName = (data: string): string => {
  return data === FIXTAB_BFF ? MICROSITE : data
}

const formatProductName = (data: IProductSchema[]): string => {
  return data
    .map((item) => item.name)
    .filter((name): name is string => Boolean(name))
    .join(', ')
}

export function formatReport(data: TicketReportInput): IReportProps[] {
  if (!Array.isArray(data)) {
    return []
  }

  const nextData: IReportProps[] = data.map((item) => {
    const extractTechnicians = (
      users: IUsersInfo[] | null | undefined,
    ): string => {
      const validUsers = safeGetArray(users)
      return validUsers
        .map((user: IUsersInfo) => user.fullName)
        .filter((name): name is string => Boolean(name))
        .join(', ')
    }

    const technicians = extractTechnicians(item.users)

    const typeObj = item.type || {}
    const taskIssueObj = item.taskIssue || {}
    const _type = safeGetString(typeObj.nameTh)
    const _taskIssue = safeGetString(taskIssueObj.nameTh)

    return {
      createdBy: formatName(safeGetString(item.createdBy)),
      createdDate: getDate(item.createdAt),
      createdTime: getTime(item.createdAt),
      updatedBy: formatName(safeGetString(item.updatedBy)),
      updatedDate: getDate(item.updatedAt),
      updatedTime: getTime(item.updatedAt),
      deletedBy: formatName(safeGetString(item.deletedBy)),
      deletedDate: getDate(item.deletedAt),
      deletedTime: getTime(item.deletedAt),
      taskId: safeGetString(item.id),
      code: safeGetString(item.code),
      reportDate: getDate(item.requestDate),
      reportTime: getTime(item.requestDate),
      priority: safeGetString(item.statusPriority),
      statusTicket: safeGetString(item.statusProgress),
      startAssignDate: getDate(item.assignStart),
      startAssignTime: getTime(item.assignStart),
      endAssignDate: getDate(item.assignEnd),
      endAssignTime: getTime(item.assignEnd),
      issueDetail: safeGetString(item.issueDetail),
      ticketType: _type,
      issueType: _taskIssue,
      reporter: safeGetString(item.contactName),
      emailReporter: safeGetString(item.contactEmail),
      reporterPhoneNumber: safeGetString(item.contactPhoneNumber),
      companyName: safeGetString(item.companyName),
      branchName: safeGetString(item.branchName),
      branchAddress: safeGetString(item.branchAddress),
      createdFrom: safeGetString(item.createdFrom),
      technicians,
      checkInDate: getDate(item.checkInAt),
      checkInTime: getTime(item.checkInAt),
      userCheckin: safeGetString(item.checkInByUser),
      pendingDate: getDate(item.pendingAt),
      pendingTime: getTime(item.pendingAt),
      userPending: safeGetString(item.pendingByUser),
      pendingDetail: safeGetString(item.pendingDetail),
      completeDate: getDate(item.completedAt),
      completeTime: getTime(item.completedAt),
      completedBy: safeGetString(item.completedByUser),
      completeDetail: safeGetString(item.completedDetail),
      closedTaskDetail: safeGetString(item.closedTaskDetail),
      closedTaskDate: getDate(item.closedTaskAt),
      closedTaskTime: getTime(item.closedTaskAt),
      closedTaskRate: safeGetString(item.closedStar),
      rejectedDetail: safeGetString(item.rejectedDetail),
      rejectedDate: getDate(item.rejectedAt),
      rejectedTime: getTime(item.rejectedAt),
      transferDate: getDate(item.transferringAt),
      transferTime: getTime(item.transferringAt),
      transferBy: safeGetString(item.transferringByUser),
      transferDetail: safeGetString(item.transferringDetail),
      products: formatProductName(item.products),
      completeDetailByTechnician: safeGetString(item.products[0]?.detail || ''),
    }
  })

  return nextData
}
